import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const LengthGarageField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className={getDefaultClasses('left')}>
      <TextInput
        id='length-garage'
        propertyName='lengthGarage'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.lengthGarage', 'Length of Garage')}</span>}
        value={insertionData.lengthGarage}
        maxLength={5}
        type='text'
        affixRight='unit'
        unitRight='meters'
        errors={validationMessages?.lengthGarage ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default LengthGarageField
